module.exports = __webpack_public_path__ + "static/img/index_banner6.e25453a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_banner6.jpg
// module id = kG6y
// module chunks = 1